import React from 'react';
import PropTypes from 'prop-types';
import DesignComponent from "./DesignComponent";

export default class PostList extends DesignComponent {
    constructor(props) {
        super(props);

        this.classNameBackgroundColor = this.classNameBackgroundColor.bind(this);

        this.indexClass = -1;
    }

    classNameBackgroundColor () {
        if(this.indexClass++ >= this.props.backgroundListColors.length) {
            this.indexClass = 0;
        }

        return this.props.backgroundListColors[this.indexClass];
    }

    render() {
        const {dataKey, className, post, messageNotFound, backgroundListColors} = this.props;

        return <section className={`${className}`} key={`${dataKey ?? ''}-post`} ref={this.refSectionList}>
            {post && post.length < 1 && <p>{messageNotFound}</p>}
            {post && post.map(p => <>
                {p.image && <div className="article lazyload" style={{backgroundImage: `url(${p.image})`}}/>}
                <a href={p.permalink}
                   className={`article ${!p.image && backgroundListColors.length > 0 ? this.classNameBackgroundColor() : 'has-grey-background-color'}`}>
                    <div className="blurb">
                        {p.types && <p className="categ">{p.types.join(', ')}</p>}

                        <p className="title">{p.title}</p>

                        {p.excerpt && <p dangerouslySetInnerHTML={{__html: p.excerpt}}/>}

                        <div className="more-info">
                            <p className="more">Read More</p>
                        </div>
                    </div>
                </a>
            </>)}
        </section>;
    }
}

PostList.propTypes = {
    dataKey: PropTypes.string,
    post: PropTypes.array.isRequired,
    className: PropTypes.string,
    messageNotFound: PropTypes.string,
    backgroundListColors: PropTypes.array
}

PostList.defaultProps = {
    dataKey: '',
    post: [],
    className: '',
    messageNotFound: '',
    backgroundListColors: []
}